import { createContext, useMemo, useState } from 'react'
import { getUserToken } from '../helpers/sessionValidation'
import PropTypes from 'prop-types';

const defaultValues = {
  token: '',
  setToken: () => {},
  loading: false,
  setLoading: () => {}
}

export const appContext = createContext(defaultValues)

export const AppProvider = ({ children }) => {
  const [token, setToken] = useState(getUserToken())
  const [loading, setLoading] = useState(false)

  const values = useMemo(() => ({ token, setToken, loading, setLoading }), [token, loading])

  return (
    <appContext.Provider value={values}>
      {children}
    </appContext.Provider>
  )
}

AppProvider.propTypes = {
  children: PropTypes.node,
};
